// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;

  background: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);

  display: flex;
  align-items: center;
  justify-content: center;
}

.subscription-card {
  background: #ffffff;
  width: 90%;
  max-width: 420px;

  padding: 28px 24px;
  border-radius: 14px;
  text-align: center;

  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
  animation: scaleIn 0.3s ease;
}

.subscription-card h2 {
  font-size: 24px;
  margin-bottom: 12px;
  color: #dc2626; /* red-600 */
}

.subscription-card p {
  font-size: 15px;
  color: #444;
  margin-bottom: 14px;
  line-height: 1.5;
}

.subscription-card .expiry {
  font-size: 14px;
  color: #6b7280;
}

.subscription-card button {
  width: 100%;
  padding: 12px;
  margin-top: 14px;

  background: linear-gradient(135deg, #0f766e, #14b8a6);
  color: white;
  border: none;
  border-radius: 8px;

  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.subscription-card button:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.4);
}

.subscription-card .whatsapp-btn {
  background: linear-gradient(135deg, #128c7e, #25d366);
}

.subscription-card .whatsapp-btn:hover {
  box-shadow: 0 8px 20px rgba(37, 211, 102, 0.4);
}

.subscription-card .support {
  margin-top: 14px;
  font-size: 13px;
  color: #6b7280;
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.92);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/subscriptionOverlay.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;;EAEb,+BAA+B;EAC/B,kCAA0B;UAA1B,0BAA0B;;EAE1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;;EAEhB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;;EAElB,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc,EAAE,YAAY;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;;EAEhB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".subscription-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(6px);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.subscription-card {\n  background: #ffffff;\n  width: 90%;\n  max-width: 420px;\n\n  padding: 28px 24px;\n  border-radius: 14px;\n  text-align: center;\n\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  animation: scaleIn 0.3s ease;\n}\n\n.subscription-card h2 {\n  font-size: 24px;\n  margin-bottom: 12px;\n  color: #dc2626; /* red-600 */\n}\n\n.subscription-card p {\n  font-size: 15px;\n  color: #444;\n  margin-bottom: 14px;\n  line-height: 1.5;\n}\n\n.subscription-card .expiry {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.subscription-card button {\n  width: 100%;\n  padding: 12px;\n  margin-top: 14px;\n\n  background: linear-gradient(135deg, #0f766e, #14b8a6);\n  color: white;\n  border: none;\n  border-radius: 8px;\n\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.subscription-card button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.4);\n}\n\n.subscription-card .whatsapp-btn {\n  background: linear-gradient(135deg, #128c7e, #25d366);\n}\n\n.subscription-card .whatsapp-btn:hover {\n  box-shadow: 0 8px 20px rgba(37, 211, 102, 0.4);\n}\n\n.subscription-card .support {\n  margin-top: 14px;\n  font-size: 13px;\n  color: #6b7280;\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.92);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
